<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-brand">
        <span class="mark">ZYT</span>
        <div>
          <h1>中云图管理后台</h1>
          <p>湖南中云图地理信息科技有限公司</p>
        </div>
      </div>
      <el-form
        class="login-form"
        ref="lform"
        :model="loginform"
        :rules="rules"
        label-width="72px"
      >
        <el-form-item label="用户名" prop="name">
          <el-input name="name" v-model="loginform.name" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input
            name="password"
            type="password"
            v-model="loginform.pass"
            autocomplete="off"
            placeholder="请输入密码"
            @keyup.enter.native="login"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="login-btn" @click="login">登录</el-button>
          <router-link class="back-link" to="/">返回官网</router-link>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginform: {
        name: "",
        pass: ""
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 5,
            max: 20,
            message: "密码长度在 5 到 20 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    login() {
      this.$refs.lform.validate(valid => {
        if (valid) {
          this.$http
            .post("Account/Login", {
              LoginName: this.loginform.name,
              Password: this.loginform.pass
            })
            .then(response => {
              const token = response.data;
              if (token) {
                this.$message({
                  message: "登录成功",
                  type: "success"
                });
                sessionStorage.setItem("token", token);
                this.$router.push({ name: "admin" });
              } else {
                this.$message({
                  message: "账号或密码错误",
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
              });
            });
        } else {
          this.$message({
            message: "请输入合法的值",
            type: "error"
          });
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at top left, rgba(58, 160, 216, 0.28), transparent 36%),
    linear-gradient(160deg, #0f2f4a 0%, #1a4b6f 48%, #0d2438 100%);
  padding: 24px;
}

.login-card {
  width: 440px;
  background: #fff;
  border-radius: 16px;
  padding: 36px 34px 28px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
}

.login-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;

  .mark {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #1f6fab, #3aa0d8);
    color: #fff;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h1 {
    margin: 0;
    font-size: 22px;
    color: #17324a;
  }

  p {
    margin: 4px 0 0;
    font-size: 12px;
    color: #7a93a8;
  }
}

.login-btn {
  width: 120px;
}

.back-link {
  margin-left: 14px;
  color: #1f6fab;
  text-decoration: none;
  font-size: 14px;
}

@media (max-width: 640px) {
  .login-page {
    padding: 16px;
  }

  .login-card {
    width: 100%;
    padding: 28px 20px 22px;
  }

  .login-brand h1 {
    font-size: 18px;
  }

  .login-btn {
    width: 100%;
  }

  .back-link {
    display: inline-block;
    margin: 12px 0 0;
  }
}
</style>
